import {
    parcoursFormaliteBasePath,
    parcoursFormaliteClientsStepPath,
    parcoursFormaliteDocsStepPath,
    parcoursFormaliteFormaliteStepPath,
    parcoursFormaliteFormStepPath,
    parcoursFormaliteNextFormStepPath,
    parcoursFormaliteRecapStepPath,
    parcoursFormalitePrescriberStepPath,
    type ParcoursFormaliteSupportedView,
    parcoursFormaliteContactStepPath,
} from './constants';

export const parcoursFormalitePathResolver = function (
    view: ParcoursFormaliteSupportedView,
    prestaIndex: number = 0,
    formPage: number = 0,
): string {
    switch (view) {
        case 'stepPrescriber':
            return ['', parcoursFormaliteBasePath, parcoursFormalitePrescriberStepPath].join('/');
        case 'stepContact':
            return ['', parcoursFormaliteBasePath, parcoursFormaliteContactStepPath].join('/');
        case 'stepFormalite':
            return ['', parcoursFormaliteBasePath, parcoursFormaliteFormaliteStepPath].join('/');
        case 'stepClient':
            return ['', parcoursFormaliteBasePath, parcoursFormaliteClientsStepPath].join('/');
        case 'stepForm':
            return [
                '',
                parcoursFormaliteBasePath,
                parcoursFormaliteFormStepPath,
                prestaIndex,
                formPage,
            ].join('/');
        case 'stepDocs':
            return ['', parcoursFormaliteBasePath, parcoursFormaliteDocsStepPath].join('/');
        case 'stepRecap':
            return ['', parcoursFormaliteBasePath, parcoursFormaliteRecapStepPath].join('/');
        case 'stepNextForm':
            return [
                '',
                parcoursFormaliteBasePath,
                parcoursFormaliteNextFormStepPath,
                prestaIndex,
                formPage,
            ].join('/');
        default:
            throw new Error(`${view} routing not implemented`);
    }
};
